<template>
    <div class="con">
        <div class="one">
            <div class="phone">
                <div class="l">
                    <input type="text" placeholder="Email add...">
                    <div>
                        <img src="../assets/aem/foot/email.png" alt="">
                    </div>                
                </div>
                <div>{{$t(`footer.contact`)}}：400-8811-938</div>
            </div>
            
           <div class="r">
               <div class="allIcons">
                   <!-- <div class="item">
                       <img src="../assets/aem/foot/f1.png" alt="">
                       <img src="../assets/aem/foot/f11.png" alt="">
                   </div>
                   <div class="item">
                       <img src="../assets/aem/foot/f2.png" alt="">
                       <img src="../assets/aem/foot/f22.png" alt="">
                   </div> -->
                   <div class="item">
                       <img src="../assets/aem/foot/f3.png" alt="">
                       <img src="../assets/aem/foot/f33.png" alt="">
                       <div class="code">
                           <img src="../assets/code.jpg" alt="">
                       </div>
                   </div>
                   <!-- <div class="item">
                       <img src="../assets/aem/foot/f4.png" alt="">
                       <img src="../assets/aem/foot/f44.png" alt="">
                   </div> -->
               </div>
           </div>
        </div>
        <div class="two">
            <div class="content">
                <div class="l">
                    <img src="../assets/aem/foot/fLogo.png" alt="">
                </div>
                <div class="aLists">
                    <div class="list" v-for="(item,index) in $t(`footer.footerList`)" :key="index">
                        <div class="item" @click="gotoPage(item)">{{item.title || ""}}</div>
                        <div class="item" v-for="(i,idx) in item.list" :key="idx" @click="gotoPage(i)">
                            {{i.title ? i.title:i}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="three">
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011202003048" target="_blank">
                粤公网安备44011202003048号 
            </a>
            <p>
                © Copyright 2020 西陇科学股份有限公司 All Rights Reservedm
                <!-- <a  href="/" target="_blank">
                    Design in by：xiLongKeXue
                </a> -->
            </p>
            <div>
                <a :href="businessImgUrl" target="_blank" style="margin-right:40px">
                    {{$t(`footer.dangerlicense`)}}
                </a>
                <a :href="licenceImgUrl" target="_blank">
                    {{$t(`footer.businesslicense`)}}
                </a>
            </div>
            <a href="https://beian.miit.gov.cn/" target="_blank">
                @ Copyright 粤ICP备2021084946号
            </a>
        </div>

        <!-- <div class="three" style="justify-content: center;">
            <a :href="businessImgUrl" target="_blank" style="margin-right: 10px;color: #fff">
                <img src="../assets/aem/foot/icon-business.png" style="width: 20px;height: 20px;margin: -5px 5px" />危险品化学品经营许可证
            </a>
            <a :href="licenceImgUrl" target="_blank" style="margin-left: 2px;color: #fff">
                <img src="../assets/aem/foot/icon-licence.png" style="width: 20px;height: 20px;margin: -5px 5px" />营业执照
            </a>
        </div> -->
    </div>
</template>

<script>
import { getFooter } from '../util/lang'
import HomeService from "@/services/HomeService"
import qs from 'qs'

export default {
    name: "foot",
    data () {
        return {
            form: {
                content: ''
            },
            list: [],
            businessImgUrl: require('../assets/aem/foot/business.jpg'), // 经营许可证
            licenceImgUrl: require('../assets/aem/foot/licence.jpg'), // 营业执照
        }
    },
    mounted () {
        this.$nextTick(() => {
            this.getNav()
        })
    },
    methods: {
        submitForm () {
            if (this.form.content == '') {
                this.$notify.info({
                    title: '提示',
                    message: '请将信息填写完整哦'
                });
            } else {
                this.$nextTick(() => {
                    const url = '/common/Form.php'
                    this.$axios.post(url,
                        qs.stringify(
                            this.form
                        )
                    ).then(res => {
                        if (res.data.code === 200) {
                            this.$notify({
                                title: '成功',
                                message: '您的信息已经成功提交',
                                type: 'success'
                            });
                            this.form = {
                                content: ''
                            }
                        }
                    }).catch(res => {
                        this.$notify.error({
                            title: '错误',
                            message: '提交失败'
                        });
                    })
                })
            }
        },
        async getNav () {
            // const {data} = await HomeService
            // const url = `${getFooter()}`
            // this.$axios.get(url).then(res => {
            //     localStorage.setItem('url', res.data.url)
            //     // pc端banner
            //     localStorage.setItem('aban1', res.data.about_1)
            //     localStorage.setItem('aban2', res.data.about_2)
            //     localStorage.setItem('aban3', res.data.about_3)
            //     localStorage.setItem('aban5', res.data.about_5)
            //     localStorage.setItem('pban1', res.data.pro_1)
            //     localStorage.setItem('pban2', res.data.pro_2)
            //     localStorage.setItem('pban3', res.data.pro_3)
            //     localStorage.setItem('pban4', res.data.pro_4)
            //     localStorage.setItem('pban5', res.data.pro_5)
            //     localStorage.setItem('nban1', res.data.news_1)
            //     localStorage.setItem('nban2', res.data.news_2)
            //     localStorage.setItem('nban3', res.data.news_3)
            //     localStorage.setItem('tban1', res.data.tzzgx_1)
            //     localStorage.setItem('tban2', res.data.tzzgx_2)
            //     localStorage.setItem('tban5', res.data.tzzgx_5)
            //     localStorage.setItem('sban', res.data.service)
            //     // 手机端banner
            //     localStorage.setItem('aban1_m', res.data.about_1_m)
            //     localStorage.setItem('aban2_m', res.data.about_2_m)
            //     localStorage.setItem('aban3_m', res.data.about_3_m)
            //     localStorage.setItem('aban5_m', res.data.about_5_m)
            //     localStorage.setItem('pban1_m', res.data.pro_1_m)
            //     localStorage.setItem('pban2_m', res.data.pro_2_m)
            //     localStorage.setItem('pban3_m', res.data.pro_3_m)
            //     localStorage.setItem('pban4_m', res.data.pro_4_m)
            //     localStorage.setItem('pban5_m', res.data.pro_5_m)
            //     localStorage.setItem('nban1_m', res.data.news_1_m)
            //     localStorage.setItem('nban2_m', res.data.news_2_m)
            //     localStorage.setItem('nban3_m', res.data.news_3_m)
            //     localStorage.setItem('tban1_m', res.data.tzzgx_1_m)
            //     localStorage.setItem('tban2_m', res.data.tzzgx_2_m)
            //     localStorage.setItem('tban5_m', res.data.tzzgx_5_m)
            //     localStorage.setItem('sban_m', res.data.service_m)



            //     localStorage.setItem('class_1', JSON.stringify(res.data.class_1))
            //     localStorage.setItem('class_2', JSON.stringify(res.data.class_2))
            //     localStorage.setItem('class_3', JSON.stringify(res.data.class_3))
            //     localStorage.setItem('class_4', JSON.stringify(res.data.class_4))

            //     this.list[0].con = this.list[0].con.concat(res.data.class_1)
            //     this.list[1].con = this.list[1].con.concat(res.data.class_2)
            //     this.list[2].con = this.list[2].con.concat(res.data.class_3)
            //     this.list[3].con = this.list[3].con.concat(res.data.class_4)
            // })
        },
        gotoPage(row) {
          const {id, url} = row;
          if (url) {
            if (['3-2', '3-3', '3-4'].includes(id)) {
                window.open(url, '_blank')
                return;
            }
            window.open(url, '_self')
          }
        },
        goto (n, i, id) {
            // if (n === 0 && i === 0) {
            //     window.open('./about.html', '_self')
            // } else if (n === 0 && i === 1) {
            //     window.open('./about.html', '_self')
            // } else if (n === 0 && i === 2) {
            //     window.open('./history.html', '_self')
            // } else if (n === 0 && i === 3) {
            //     window.open('./honor.html', '_self')
            // } else if (n === 0 && i === 4) {
            //     window.open('./join.html', '_self')
            // } else if (n === 1 && i === 0) {
            //     window.open('./product.html', '_self')
            // } else if (n === 1 && i === 1) {
            //     window.open('./product.html', '_self')
            // } else if (n === 1 && i === 2) {
            //     window.open('./material.html', '_self')
            // } else if (n === 1 && i === 3) {
            //     window.open('./health.html', '_self')
            // } else if (n === 1 && i === 4) {
            //     window.open('./brand.html', '_self')
            // } else if (n === 1 && i === 5) {
            //     window.open('./internet.html', '_self')
            // } else if (n === 2 && i === 0) {
            //     window.open('./gover.html', '_self')
            // } else if (n === 2 && i === 1) {
            //     window.open('./gover.html', '_self')
            // } else if (n === 2 && i === 2) {
            //     window.open('http://www.cninfo.com.cn/new/disclosure/stock?stockCode=002584&orgId=9900019958#latestAnnouncement', '_blank', 'noreferrer')
            // } else if (n === 2 && i === 3) {
            //     window.open('http://www.csrc.gov.cn/pub/newsite/tzzbh1/', '_blank')
            // } else if (n === 2 && i === 4) {
            //     window.open('http://ir.p5w.net/c/002584.shtml', '_blank')
            // } else if (n === 2 && i === 5) {
            //     window.open('./onLine.html', '_self')
            // } else if (n === 3 && i === 0) {
            //     window.open('./news.html', '_self')
            // } else if (n === 3 && i === 1) {
            //     window.open('./news.html?type=0', '_self')
            // } else if (n === 3 && i === 2) {
            //     window.open('./news.html?type=1', '_self')
            // } else if (n === 3 && i === 3) {
            //     window.open('./news.html?type=2', '_self')
            // } else if (n === 4 && i === 0) {
            //     window.open('./service.html', '_self')
            // } else if (n === 4 && i === 1) {
            //     window.open('./service.html?type=0', '_self')
            // } else if (n === 4 && i === 2) {
            //     window.open('./service.html?type=1', '_self')
            // }
        }
    }
}
</script>

<style lang="scss" scoped>
.con {
    width: 100%;
    background-size: cover;
    position: relative;
    background-color: #2e3133;    

    .one {
        width: 80%;
        margin: 0 auto;
        padding: 50px 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;    
        .phone{
            display: flex;
            align-items: center;
            color: #fff;
        }    

        .l {
            display: inline-block;
            position: relative;
            width: 431px;
            height: 46px;
            margin-right: 20px;
            background: rgba(244, 244, 244, 0.05);

            input {
                width: 100%;
                display: block;
                height: 100%;
                border: none;
                outline: none;
                color: white;
                background: transparent;
                text-indent: 10px;
                font-family: "it";
            }

            div {
                position: absolute;
                right: 5%;
                top: 15px;
                cursor: pointer;
            }
        }

        .r {
            display: flex;
            flex-direction: row;
            align-items: center;

            .item {
                display: inline-block;
                position: relative;
                margin: 0 10px;
                cursor: pointer;
                .code {
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                    top: 100%;
                    width: 80px;
                    height: 80px;
                    opacity: 0;
                    transition: all 500ms;
                    padding-top: 10px;
                    img {
                        width: 100%;
                        display: block;
                        object-fit: contain;
                    }
                }

                img {
                    display: block;
                    transition: all 500ms;
                    width: 100%;
                    object-fit: contain;
                }

                img:nth-child(2) {
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    opacity: 0;
                }

                &:hover {
                    img:nth-child(1) {
                        opacity: 0;
                    }

                    img:nth-child(2) {
                        opacity: 1;
                    }
                    .code {
                        opacity: 1;
                        img {
                            opacity: 1 !important;
                        }
                    }
                }
            }
        }
    }

    .two {
        width: 100%;
        padding: 60px 0;
        border: {
            top: 1px solid rgba(244, 244, 244, 0.13);
            bottom: 1px solid rgba(244, 244, 244, 0.13);
        }

        .content {
            width: 80%;
            margin: 0 auto;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            .l {
                width: 20%;
                text-align: center;
                margin-right: 5%;
            }
            .aLists {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                width: 70%;
                .list {
                    .item {
                        color: rgba(98, 113, 117, 1);
                        font-size: 14px;
                        font-family: "SOURCEHANSANSCN-LIGHT";
                        //text-transform: uppercase;
                        margin-top: 10px;
                        cursor: pointer;
                        font-weight: lighter;
                        transition: all 500ms;
                        text-align: center;

                        &:hover {
                            color: white;
                        }
                    }

                    .item:nth-child(1) {
                        font-size: 16px;
                        color: white;
                        //text-transform: uppercase;
                        margin-top: 0;
                        margin-bottom: 20px;
                        font-family: "SOURCEHANSANSCN-NORMAL";
                    }
                }
            }
        }
    }

    .three {
        width: 80%;
        margin: 0 auto;
        padding: 30px 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        p,
        a {
            color: rgba(140, 150, 152, 0.27);
            font-size: 14px;
            font-family: "SOURCEHANSANSCN-NORMAL";
        }
        a {
            transition: all 500ms;
            &:hover {
                color: rgba(140, 150, 152, 1);
            }
        }
    }

    @media screen and (max-width: 1000px) {
        .one {
            width: 90%;
            padding: 15px 0;
            .l {
                width: 50%;
            }
            .r {
                width: 45%;
                display: block;
                .allIcons {
                    width: 100%;
                    justify-content: space-between;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                }
                .item {
                    margin: 0 auto;
                }
            }
        }
        .two {
            padding: 30px 0;
            .content {
                .l {
                    width: 100%;
                    margin-right: 0;
                }
                .aLists {
                    display: none;
                }
            }
        }
        .three {
            width: 90%;
            flex-direction: column;
            text-align: center;
            padding: 15px 0;
            a {
                margin-top: 10px;
            }
        }
    }
}
</style>
